export type FilterState = {
  search: string;
  sort: SortTypes;
  code: CodeTypes;
  filters: FilterTag[];
};

export type CodeTypes = 'gerdau' | 'interno';

export type SortTypes = 'R' | 'AC' | 'AB';

export type FilterTag = {
  id: string;
  value: string;
  label: string;
};

export type ChipsType = {
  label: string;
  id: string;
};

export enum EFiltersActions {
  ADD_CATEGORY = 'ADD_CATEGORY',
  REMOVE_CATEGORY = 'REMOVE_CATEGORY',
  CLEAR_FILTERS = 'CLEAR_FILTERS',
  BUILD_FILTERS = 'BUILD_FILTERS',
  ADD_SEARCH = 'ADD_SEARCH',
  REMOVE_SEARCH = 'REMOVE_SEARCH',
  SET_SORT = 'SET_SORT',
  SET_MATERIAL_CODE = 'SET_MATERIAL_CODE'
}

type AddCategory = {
  type: EFiltersActions.ADD_CATEGORY;
  payload: FilterTag;
};

type RemoveCategory = {
  type: EFiltersActions.REMOVE_CATEGORY;
  payload: FilterTag['id'];
};

type ClearFilters = {
  type: EFiltersActions.CLEAR_FILTERS;
};

type AddSearch = {
  type: EFiltersActions.ADD_SEARCH;
  payload: string;
};

type RemoveSearch = {
  type: EFiltersActions.REMOVE_SEARCH;
};

type SetSort = {
  type: EFiltersActions.SET_SORT;
  payload: SortTypes;
};

type SetMaterialCode = {
  type: EFiltersActions.SET_MATERIAL_CODE;
  payload: CodeTypes;
};

export type FilterActions =
  | AddCategory
  | RemoveCategory
  | ClearFilters
  | AddSearch
  | RemoveSearch
  | SetSort
  | SetMaterialCode;
